import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const NonagonShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 411.6 405.5",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M205.8 0L71.5 48.9 0 172.7l24.8 140.8 109.5 92h143l109.5-92 24.8-140.8-71.5-123.8z"
    })
  });
};

export { NonagonShape };
//# sourceMappingURL=NonagonShape.js.map
